/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import styled from '@themes/theme'
import { getAccountTypeText } from '@utils/utils'
import { TransferableAccount } from '@store/userStore'
import useRootStore from '@store/useRootStore'
import * as _ from 'lodash'
import dayjs from 'dayjs'
import * as Utils from '@utils/utils'

export const ApplyForAccountTransferInfoWrap = styled.div`
  .account-transfer {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.color.modalSubBg};
    display: flex;
    justify-content: space-between;
    line-height: 48px;
    padding: 0 20px;
    margin-bottom: 14px;
    &--name, &--address {
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalTxt};
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: ${props => props.theme.color.modalBg};
    margin: 14px 0;
  }
  .modal-body-txt {
    padding: 0 15px;
    color: ${props => props.theme.color.modalgray} !important;
    font-size: ${props => props.theme.font.medium} !important;
    font-weight: ${props => props.theme.fontW.medium};
  }
`

interface ApplyForAccountTransferInfoProps {
  accountInfo: TransferableAccount
}

export const ApplyForAccountTransferInfo: React.FC<ApplyForAccountTransferInfoProps> = observer((props) => {
  const { globalStore } = useRootStore()
  const { accountInfo } = props
  const { sign, accountName } = accountInfo

  const accountTransferOpt = globalStore.getAccountTransferOptions()

  let endDateText: string
  if (!_.isEmpty(accountTransferOpt?.period?.to)) {
    const to = accountTransferOpt.period.to
    const endDate = dayjs(to)
    endDateText = `${endDate.format('YYYY.M.D')}(${Utils.getDayOfWeeks(to)})`
  }

  return (
    <ApplyForAccountTransferInfoWrap>
      <div className="account-transfer">
        <p className="account-transfer--name">{getAccountTypeText(sign)}</p>
        <p className="account-transfer--address">{accountName}</p>
      </div>
      <p className="point-color--orange--modal">{`이관 예정일 ${endDateText} 정기점검`}</p>
      <div className="line"/>
      <div className="modal-body-txt">
        이관 완료 후에는 재신청 및 취소, 원복할 수 없습니다.
        이관 전까지 카카오 계정을 정상적으로 이용할 수 있습니다.
      </div>
    </ApplyForAccountTransferInfoWrap>
  )
})
